module.exports = __webpack_public_path__ + "media/site_templates/www.localgardeners.com.au/images/feature_3-15c0ee4c520fbb4557583daf9faf3ab5.jpeg";